import messagesES from "./messages/es";

export default function messageFactory(
  message = {
    msg: 'Error desconocido. Por favor, repórtalo en <a href="https://it.cecotec.cloud">it.cecotec.cloud</a>',
  },
) {
  return messagesES(message);
}

export function getMessageFromKey(type, ...config) {
  return messageFactory(
    {
      type,
      msg: 'Error desconocido. Por favor, repórtalo en <a href="https://it.cecotec.cloud">it.cecotec.cloud</a>',
    },
    ...config
  );
}

export function getMessageFromAxiosResponse(axiosResponse, ...config) {
  return messageFactory(axiosResponse?.data?.detail, ...config);
}

export function getMessageFromAxiosError(axiosError, ...config) {
  return messageFactory(axiosError?.response?.data?.detail, ...config);
}

export function getMessageFromFetchError(fetchError, ...config) {
  return messageFactory(fetchError, ...config);
}
